import React, { useEffect } from "react";
// import "./App.css";
import { PersistGate } from "redux-persist/integration/react";
import { Provider } from "react-redux";
import { store, persistor } from "./redux/storeConfig/store";
import Toast from "./components/toast/Toast";
import Loader from "./components/Loader";
import AppRoutes from "./routes/AppRoutes";
import { Helmet } from "react-helmet";
// import LogoContainer from "../src/assets/images/logo-container.svg";
import { useSelector } from "react-redux";
import TimerContextProvider from "./context/timer/TimerContextProvider";
import { PaymentSuccess } from "./components/PaymentSuccess/PaymentSuccess";
import { PaymentFailed } from "./components/PaymentFailed/PaymentFailed";

const FINAL_STATUS = {
  SUCCESSFUL: "SUCCESSFUL",
};

function App() {
  const { orderDetails, finalOrderResponse } = useSelector(
    (state) => state.orderDetailsReducer
  );
  const merchantName = orderDetails?.data?.subsidiary?.name;
  const merchantLogo = ""; //orderDetails?.data?.subsidiary?.customization[0].value;

  useEffect(() => {
    if (finalOrderResponse && finalOrderResponse?.redirectUrl) {
      if (window?.top) {
        let redirectUrl = finalOrderResponse.redirectUrl;

        // Ensure URL has a protocol to prevent relative URL issues (case-insensitive)
        const lowerCaseUrl = redirectUrl.toLowerCase();
        if (
          !lowerCaseUrl.startsWith("http://") &&
          !lowerCaseUrl.startsWith("https://")
        ) {
          redirectUrl = "https://" + redirectUrl;
        }

        window.top.location.href = redirectUrl;
      }
    }
  }, [finalOrderResponse]);

  if (finalOrderResponse) {
    const finalStatus = finalOrderResponse?.status?.toUpperCase();
    return finalStatus === FINAL_STATUS.SUCCESSFUL ? (
      <PaymentSuccess message={finalOrderResponse?.message} />
    ) : (
      <PaymentFailed message={finalOrderResponse?.message} />
    );
  }

  return (
    <TimerContextProvider>
      <Provider store={store}>
        <PersistGate loading={<Loader />} persistor={persistor}>
          <AppRoutes />
          <Loader />
          <Toast />
          <Helmet>
            <meta charSet="utf-8" />
            <title>{merchantName}</title>
            <meta name="description" content={merchantName} />
            <link rel="canonical" href="http://mysite.com/example" />
            <link
              rel="icon"
              type="image/png"
              href={merchantLogo}
              sizes="16x16"
              data-react-helmet="true"
            />
          </Helmet>
        </PersistGate>
      </Provider>
    </TimerContextProvider>
  );
}

export default App;
